import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles';

export const header = css`
  margin: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &:after {
    content: "";
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: ${colors.gray.light};
  }
`;

export const subHeader = css`
  margin: 20px;
  display: flex;
  flex-direction: row;

  > :first-child {
    width: 150px;
  }

  > :not(:first-child) {
    margin-left: 10px;
  }
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;

  > span {
    max-width: 300px;
  }
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const placeholderWithTextButton = css`
  ${placeholder} margin-bottom: 60px;
`;
